import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './styles';
import ARROW_ICON from '../../../images/icons/dropdownArrow.svg';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { BREADCRUMBS_LINKS } from './constants';
import { URL } from '../../../utils/constants/general';

const DropdownMenu = () => {
	const [open, setOpen] = useState(false);
	const anchorRef = useRef(null);
	const { t } = useTranslation();
	const classes = useStyles();

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const handleKeyDown = event => {
		if (event.key === 'Tab') {
			setOpen(false);
		}
	};

	const handleClose = event => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	return (
		<div>
			<Button
				ref={anchorRef}
				aria-controls={open ? 'menu-list-grow' : undefined}
				aria-haspopup="true"
				className={classes.button}
				onClick={handleToggle}
				disableRipple>
				<Typography variant="body1" style={{ color: '#212529', fontWeight: 700, marginBottom: 0 }}>
					{t('main:components.breadcrumbs.prt')}
				</Typography>
				<img src={ARROW_ICON} width="12" height="12" alt={'arrow icon'} style={{ marginLeft: 8 }} />
			</Button>
			<Popper open={open} anchorEl={anchorRef.current} transition disablePortal className={classes.popper}>
				{({ TransitionProps }) => (
					<Grow {...TransitionProps}>
						<Paper className={classes.list}>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList autoFocus={open}>
									<MenuItem component="a" href={URL.PRT_PLUS} style={{ fontWeight: 600, fontSize: 16 }}>
										{t('main:components.breadcrumbs.linkLabels.prt')}
									</MenuItem>
									{BREADCRUMBS_LINKS.map((link, index) =>
										index === BREADCRUMBS_LINKS.length - 1 ? (
											<MenuItem key={index} component="a" href={link.url} tabIndex={0} onKeyDown={handleKeyDown}>
												{link.label}
											</MenuItem>
										) : (
											<MenuItem key={index} component="a" href={link.url} tabIndex={0}>
												{link.label}
											</MenuItem>
										)
									)}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</div>
	);
};

export default DropdownMenu;
